<template>
    <div>
        <limitless-page-header title="Ekonomi" :sub-title="'Kortstatistik - ' + (isNaN(year) ? year : (year ? ' ' + (year) + '-09-01 - ' + (parseInt(year) + 1) + '-08-31' : ''))"></limitless-page-header>

        <div class="content">
            <i v-if="loading" class="icon-spinner2 spinner"></i>
            <div v-else-if="report" class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-3">
                            <vue-select
                                :value="year"
                                :options="years"
                                @option:selected="$router.push({ name: 'economy.stats.cardseries', params: { year: $event } })"
                            ></vue-select>
                        </div>
                        <div class="col-auto">
                            <div class="btn-group">
                                <button type="button" class="btn" :class="{ 'btn-light': !show_redeemed, 'btn-primary': show_redeemed }" @click="show_redeemed = true;">Inlöst</button>
                                <button type="button" class="btn" :class="{ 'btn-light': show_redeemed, 'btn-primary': !show_redeemed }" @click="show_redeemed = false;">Ej inlöst</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive mb-0">
                    <table class="table table-xs">
                        <thead>
                            <tr>
                                <th>Serie</th>
                                <th>Benämning</th>
                                <th class="text-right">Antal sålda kort</th>
                                <th class="text-right">Antal aktiverade kort</th>
                                <th class="text-right">Antal <span v-if="!show_redeemed">ej </span>inlösta</th>
                                <th class="text-right">% <span v-if="!show_redeemed">ej </span>inlösta</th>
                                <th class="text-right">Snitt Kortpris</th>
                                <th class="text-right">Tot Kortpris</th>
                                <th class="text-right">Snitt Kostnad</th>
                                <th class="text-right">Tot Kostnad</th>
                                <th class="text-right">Inlösta Kostnad</th>
                                <th class="text-right">TB Just nu</th>
                                <th class="text-right">TG Just nu</th>
                                <th class="text-right">TB Prognos</th>
                                <th class="text-right">TG Prognos</th>
                            </tr>
                        </thead>
                        <tbody v-if="report.table.length > 0">
                            <tr
                                v-for="(row, r_index) in report.table"
                                :key="'row-' + r_index"
                            >
                                <td><router-link :to="{ name: 'economy.stats.cards', params: { cardSeriesId: row.CardSeriesID, year: year, mode: (show_redeemed ? 'redeemed' : 'notredeemed') } }">{{ row.CardSeriesID }}</router-link></td>
                                <td>{{ row.SeriesName }}</td>
                                <td class="text-right">{{ formatNumber(row.cards_sold, 0) }}</td>
                                <td class="text-right">{{ formatNumber(row.cards_active, 0) }}</td>
                                <td v-if="show_redeemed" class="text-right">{{ formatNumber(row.num_redeemed, 0) }}</td>
                                <td v-else class="text-right">{{ formatNumber(row.cards_sold - row.num_redeemed, 0) }}</td>
                                <td v-if="show_redeemed" class="text-right">{{ row.cards_sold > 0 ? formatNumber((row.num_redeemed / row.cards_sold) * 100, 1) : 0 }} %</td>
                                <td v-else class="text-right">{{ row.cards_sold > 0 ? formatNumber(100 - ((row.num_redeemed / row.cards_sold) * 100), 1) : 0 }} %</td>
                                <td class="text-right">{{ (row.cards_avg_price !== null ? formatNumber(row.cards_avg_price, 2) : '') }}</td>
                                <td class="text-right">{{ formatNumber(row.cards_price, 2) }} kr</td>
                                <td class="text-right">{{ (row.cards_avg_cost !== null ? formatNumber(row.cards_avg_cost, 2) : '') }}</td>
                                <td class="text-right">{{ formatNumber(row.cards_cost, 2) }} kr</td>
                                <td class="text-right">{{ formatNumber(row.cards_cost_redeemed, 2) }} kr</td>
                                <td class="text-right">{{ formatNumber(row.cards_price-row.cards_cost, 2) }} kr</td>
                                <td class="text-right">{{ row.cards_price > 0 ? formatNumber(((row.cards_price-row.cards_cost)/row.cards_price)*100, 1) + ' %' : '' }}</td>
                                <td class="text-right">{{ row.num_redeemed > 0 && row.cards_sold > 0 ? formatNumber(row.cards_price-(row.cards_cost_redeemed/row.num_redeemed)*row.cards_sold, 2) + ' kr' : '' }}</td>
                                <td class="text-right">{{ row.num_redeemed > 0 && row.cards_sold > 0 ? formatNumber((row.cards_price-(row.cards_cost_redeemed/row.num_redeemed)*row.cards_sold)/row.cards_price*100, 1) + ' %' : '' }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="14"><i>Ingen data</i></td>
                            </tr>
                        </tbody>
                        <tfoot v-if="report.table.length > 0">
                            <tr>
                                <th></th>
                                <th></th>
                                <th class="text-right"> {{ formatNumber(report.totals.cards_sold, 0) }}</th>
                                <th class="text-right"> {{ formatNumber(report.totals.cards_active, 0) }}</th>
                                <th v-if="show_redeemed" class="text-right"> {{ formatNumber(report.totals.num_redeemed, 0) }}</th>
                                <th v-else class="text-right"> {{ formatNumber(report.totals.cards_sold - report.totals.num_redeemed, 0) }}</th>
                                <th v-if="show_redeemed" class="text-right">{{ formatNumber((report.totals.num_redeemed / report.totals.cards_sold) * 100, 1) }} %</th>
                                <th v-else class="text-right">{{ formatNumber(100 - ((report.totals.num_redeemed / report.totals.cards_sold) * 100), 1) }} %</th>
                                <th class="text-right">{{ (report.totals.cards_avg_price !== null ? formatNumber(report.totals.cards_avg_price, 2) : '') }}</th>
                                <th class="text-right">{{ formatNumber(report.totals.cards_price, 2) }} kr</th>
                                <th class="text-right">{{ (report.totals.cards_avg_cost !== null ? formatNumber(report.totals.cards_avg_cost, 2) : '') }}</th>
                                <th class="text-right">{{ formatNumber(report.totals.cards_cost, 2) }} kr</th>
                                <th class="text-right">{{ formatNumber(report.totals.cards_cost_redeemed, 2) }} kr</th>
                                <th class="text-right">{{ formatNumber(report.totals.cards_price-report.totals.cards_cost, 2) }} kr</th>
                                <th class="text-right">{{ formatNumber(((report.totals.cards_price-report.totals.cards_cost)/report.totals.cards_price)*100, 1) }} %</th>
                                <th class="text-right">
                                    {{ report.totals.num_redeemed > 0 && report.totals.cards_sold > 0
                                    ? formatNumber(report.totals.cards_price-(report.totals.cards_cost_redeemed/report.totals.num_redeemed)*report.totals.cards_sold, 2) + ' kr'
                                    : '' }}
                                </th>
                                <th class="text-right">
                                    {{ report.totals.num_redeemed > 0 && report.totals.cards_sold > 0
                                    ? formatNumber((report.totals.cards_price-(report.totals.cards_cost_redeemed/report.totals.num_redeemed)*report.totals.cards_sold)/report.totals.cards_price*100, 1) + ' %'
                                    : '' }}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import apiClient from '@services/ApiClient';
import { formatNumber } from '@services/Helpers';
import VueSelect from '@components/Wrappers/VueSelect.vue';

export default {
    components: {
        VueSelect,
        LimitlessPageHeader,
    },
    props: {
        year: {
            type: [Number, String],
        },
    },
    data: () => ({
        loading: false,
        show_redeemed: true,
        report: null,
    }),
    mounted() {
        this.init();
    },
    watch: {
        year() {
            this.init();
        },
    },
    methods: {
        formatNumber,
        init() {
            const today = new Date();
            if (!this.year || this.year > today.getFullYear()) {
                this.$router.push({ name: 'economy.stats.cardseries', params: { year: (today.getMonth() < 8 ? today.getFullYear() - 1 : today.getFullYear()) } });
            } else {
                this.getData();
            }
        },
        getData() {
            this.loading = true;
            apiClient.get('/vue/economy/stats/cardseries?year=' + this.year)
                .then((response) => {
                    this.report = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        years() {
            const today = new Date();
            const options = [];
            // eslint-disable-next-line no-plusplus
            for (let i = (today.getMonth() < 8 ? today.getFullYear() - 1 : today.getFullYear()); i >= 2005; i--) {
                options.push(i);
            }
            return options;
        },
    },
};

</script>
